module.exports = "/content/5825f033c6ff12cd1ed1f3c99dff5e4b.svg";